<script async setup lang="ts">
//TODO: REFACTOR MAP

import { CULTURE, MAP_ID, MAP_KEY } from '@/composables/helpers'
import type { IAccoItem } from '@/composables/interfaces/apiInterfaces'
import t from '@/i18n/translations'
import { filterStore } from '@/store/filter.store'
import { XMarkIcon } from '@heroicons/vue/24/solid'
import Button from 'primevue/button'
import { onMounted, ref, watch } from 'vue'
import { CustomControl, GoogleMap, Marker, MarkerCluster } from 'vue3-google-map'
import AccoItemRating from '../accoitem/AccoItemRating.vue'
import FilterButton from './FilterPageButton.vue'
import SideBarFilter from './FilterPageSideBarFilter.vue'

interface IAccoMarker extends IAccoItem {
  id: number
  position: {
    lat: number
    lng: number
  }
}

const props = defineProps<{
  accos: Array<IAccoItem>
}>()

const emit = defineEmits(['map-search', 'show-filters', 'close'])

const selectedMarker = ref<IAccoMarker | null>()
const center = ref({
  lat: 46.71617,
  lng: 11.509486
})
const loading = ref(false)
let markers: IAccoMarker[] = []

function onOpenAcco(marker: IAccoMarker): void {
  window.open(marker.accoUrl, '_blank')
}

function onMarkerClick(marker: IAccoMarker): void {
  selectedMarker.value = marker
}

function onCloseItem(): void {
  selectedMarker.value = null
}

watch(
  props.accos,
  (accos) => {
    loading.value = true
    markers = accos.map((item) => {
      return {
        ...item,
        id: item.companyId,
        position: {
          lat: item.latitude,
          lng: item.longitude
        }
      }
    })
    setTimeout(() => {
      loading.value = false
    }, 100)
  },
  { deep: true }
)

onMounted(() => {
  emit('map-search')
})
</script>

<template>
  <div class="relative flex h-full gap-4">
    <div class="absolute z-20 hidden h-full w-1/4 overflow-auto bg-white pr-12 lg:block lg:p-2">
      <SideBarFilter :hideMap="true" :accos="accos || []"></SideBarFilter>
    </div>
    <div class="relative right-0 h-full w-full lg:absolute lg:w-9/12">
      <div
        class="b-0 absolute bottom-4 left-0 right-0 z-10 m-auto flex h-[160px] w-[96%] max-w-[700px] cursor-pointer rounded-md bg-white p-1"
        v-if="selectedMarker"
        @click="onOpenAcco(selectedMarker)"
      >
        <img class="relative h-full w-[25%] object-cover" :src="selectedMarker.img" />
        <div class="flex w-full flex-col gap-1 pl-2 pr-2">
          <div class="flex justify-between">
            <h1 class="mt-1 text-lg font-bold">
              {{ selectedMarker.companyName }}
            </h1>
            <XMarkIcon class="w-8 cursor-pointer drop-shadow-2xl" @click="onCloseItem()" />
          </div>
          <div class="flex w-full items-center justify-between gap-2" v-if="selectedMarker.assessmentRating != '0'">
            <AccoItemRating :is-superior="selectedMarker.isSuperior" :rating="selectedMarker.rating" :symbol-class="selectedMarker.symbolClass" />
            <div class="flex items-center justify-end gap-2">
              <div class="inline-flex items-center gap-2 rounded-[16px] border-2 px-2 py-1 text-[11px] font-bold text-surface-700">
                {{ selectedMarker.assessmentRating }}
              </div>
              <div class="-mt-1 text-[11px]">
                <div class="font-bold">
                  {{ selectedMarker.assessmentNote }}
                </div>
                <div>{{ selectedMarker.ratings }} {{ t(`${CULTURE}.acco.ratings[${selectedMarker.ratings > 1 ? 'plural' : 'singular'}]`) }}</div>
              </div>
            </div>
          </div>

          <div class="text-[14px]">{{ selectedMarker.location }}</div>
          <div>
            <Button
              size="small"
              class="pui-filterButton p-2 text-[12px]"
              :label="t(`${CULTURE}.filter.map.labelOpenAcco`)"
              @click="onOpenAcco(selectedMarker)"
            />
          </div>
        </div>
      </div>
      <div class="pui-filterButton absolute right-4 top-4 z-20 size-8 cursor-pointer">
        <XMarkIcon class="fill-black" @click="emit('close')" />
      </div>
      <GoogleMap
        :api-key="MAP_KEY"
        :map-id="MAP_ID"
        :center="filterStore.areaId && markers && markers.length ? markers[0].position : center"
        :zoom="filterStore.areaId ? 12 : 9"
        :fullscreenControl="false"
        :mapTypeControl="false"
        class="h-full w-full"
      >
        <CustomControl position="TOP_LEFT">
          <FilterButton :hidden-media="'lg'" class="left-4 top-4 lg:hidden" @showFilters="emit('show-filters')" />
        </CustomControl>
        <MarkerCluster v-if="!loading && markers">
          <Marker
            v-for="(m, i) in markers"
            :key="i"
            :options="{
              position: m.position,
              clickable: true
            }"
            @click="
              () => {
                onMarkerClick(m)
              }
            "
          >
          </Marker>
        </MarkerCluster>
      </GoogleMap>
    </div>
  </div>
</template>

<style scoped>
.icon-gradient {
  background: rgb(0, 0, 0);
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.4962359943977591) 25%, rgba(255, 255, 255, 0) 50%);
}
</style>
